import React from 'react';
import PropTypes from 'prop-types';

import Navbar from '../../components/navbar';
import { Footer } from '../../components';
import { StyledWrapper } from './MainLayout.styled';
import {
  StyledWrapChildren,
} from './MainLayout.styled';

const MainLayout = (props) => {
  const { children } = props;
  return (
    <div>
      <Navbar />
      <StyledWrapChildren>
        <StyledWrapper>{children}</StyledWrapper>
      </StyledWrapChildren>
      <Footer />
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.any,
};

export default MainLayout;
